import { Table } from 'antd';
import React, { Component } from 'react';
import NotifyApi from '../../functions/api/user/NotifyApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';

class ListNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listNotifications: [],
    };
  }

  async componentDidMount() {
    const list = await NotifyApi.getAllNotify();
    if (list) {
      let listNoti = [];
      list.forEach((element, index) => {
        element = Object.assign(element, {
          noti_push: MyUtil.getDatetimeFormatCrta(
            new Date(element['noti_date_push'])
          ),
        });
        listNoti.push(element);
      });
      this.setState({ listNotifications: listNoti });
    }

    await NotifyApi.markRead();
  }

  render() {
    const { listNotifications } = this.state;

    const columnNotif = [
      {
        title: 'Ngày nhận',
        dataIndex: 'noti_push',
        key: 'noti_push',
        width: '40%',
      },
      {
        title: 'Thông báo',
        dataIndex: 'noti_mess',
        key: 'noti_mess',
        ...TableUtils.getColumnSearchProps('noti_mess'),
      },
    ];

    return (
      <div className="content">
        <Table
          rowClassName={(record) =>
            record.unread === true ? 'table-row-highlight' : ''
          }
          rowKey="noti_push"
          size="small"
          columns={columnNotif}
          dataSource={listNotifications}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default ListNotification;
